import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { promise } from 'protractor';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators'
import { firebaseUser } from 'src/app/interfaces/firebaseUser';
import { user_all_info } from 'src/app/interfaces/user_all_info';

@Injectable({
  providedIn: 'root'
})
export class DbService {
  private mainUrl = 'https://cgsportingapi.herokuapp.com/'
  constructor(private db:AngularFirestore, private http:HttpClient, private afAuth: AngularFireAuth ) { }

    getCategorieCourses(categoire){

      return this.http.get(`${this.mainUrl}categories/${categoire}`);
      
      // return this.db.collection('categories').doc(categoire).valueChanges();
    }

    getVideosBylevel(level){
      return this.http.get(`${this.mainUrl}videos/${level}`)
    }

    getEjerciciosDelDia(nivel){
      switch (nivel) {
        case 'principiante':
          return this.http.get(`${this.mainUrl}videos/7344663`)
          break;
          case 'intermedio':
            return this.http.get(`${this.mainUrl}videos/7344712`)
            break;
            case 'avanzado':
              return this.http.get(`${this.mainUrl}videos/7344748`)
              break;     
              case 'brazo':
              return this.http.get(`${this.mainUrl}videos/8781176`)
              break;  
              case 'pierna':
              return this.http.get(`${this.mainUrl}videos/8781168`)
              break;  
              case 'nucleo':
              return this.http.get(`${this.mainUrl}videos/8781185`)
              break;   
              case '7min':
              return this.http.get(`${this.mainUrl}videos/8778644`)
              break; 
              case 'silla_brazo':
              return this.http.get(`${this.mainUrl}videos/9771595`)
              break; 
              case 'silla_nucleo':
              return this.http.get(`${this.mainUrl}videos/9771667`)
              break;
              case 'silla_mixto':
              return this.http.get(`${this.mainUrl}videos/9771673`)
              break;
              case 'estiramientos_dinamicos':
              return this.http.get(`${this.mainUrl}videos/9771691`)
              break;
              case 'explicacion_ejercicios_rapidos':
              return this.http.get(`${this.mainUrl}videos/9788240`)
              break;
        default:
          break;
      }
    }

    9788240

    getLiveConfig(categorie){
      return this.db.collection('config').doc(categorie).valueChanges();
    }

    getFichaTecnica(sesion){
      const promise  = new Promise(resolve => {
        this.http.get('assets/jsons/fichas.json').subscribe((allFichas:any) => {
          resolve(allFichas.sesiones[sesion.id-1])
        })
      });
      return  promise;
    }

    getVideosSesion(sesion){
      const promise  = new Promise(resolve => {
        this.http.get('assets/jsons/videosSesion.json').subscribe((allVideos:any) => {
          resolve(allVideos[`${sesion.id}`]);
        })
      });
      return  promise;
    }

    getMicrociclos(){
      let obs = new Observable(subs => {
        this.http.get('assets/jsons/microCiclos.json').subscribe((data:any) => {
          subs.next(data.data);
          subs.complete();
        })
      })
      return obs
    }

    saveToLocaDb(key:string, value:any){
      const jsonToSave = JSON.stringify(value);
      localStorage.setItem(key,jsonToSave);
    }

    async saveUser(){
      const userBasicData:user_all_info = JSON.parse(localStorage.getItem('user_basic_data'));
      const currentUser:firebaseUser = JSON.parse(localStorage.getItem('currentUser'));
      const canContact = JSON.parse(localStorage.getItem('canContact'));

      const userAllInfo: user_all_info = { ...userBasicData, ...currentUser, ...canContact};
      debugger;
      
      const f_request = await this.db.collection('users').doc(currentUser.uid).set(userAllInfo)

      return f_request;      
    }

    saveProfileInfo(profileInfo: user_all_info){
      const currentUser = JSON.parse( localStorage.getItem('currentUser')) as firebaseUser;
      return this.db.collection('users').doc(currentUser.uid).update(profileInfo)
    }

      getUserProfileInfo(){
      const currentUser = JSON.parse(localStorage.getItem('currentUser')) as firebaseUser;
       return  this.db.collection('users').doc(currentUser.uid).valueChanges();  
      
    }

    getAllCountries(){
      return this.http.get(`${this.mainUrl}geonames`)
    }

    getCitiesFromCountry(country){
      return this.http.get(`${this.mainUrl}geonames/${country}`)
    }

}
